import useUrlParams from '../../hooks/useUrlParams';
import './CommandCenter.scss'
import Hud from './hud/Hud';
import Monitor from './monitor/Monitor';
import Planning from './planning/Planning';

const CommandCenter = () => {
  const {
    tab_name
  } = useUrlParams()


  return (
    <div className='command__center_container'>
      {/* // Contact Section // */}
      {tab_name === 'hud' && <Hud />}
      {tab_name?.includes('plan') && <Planning />}
      {tab_name === 'monitor' && <Monitor />}
      {/* // Contact Section // */}
    </div>
  )
}

export default CommandCenter